// extracted by mini-css-extract-plugin
export default {"mCard":"lE-z","image":"mE-z","imageNoBackground":"nE-z","imageHasCategory":"oE-z","fullWidth":"pE-z"};